"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports.moveAt=function(e,t){var r=e.value-e.shift,i=r<e.min?e.min:r>e.max?e.max:r;if(t){var a=t.value-t.shift;return[i,a<t.min?t.min:a>t.max?t.max:a]}return[i]};
